<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'common.move'">_Mover</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info"
      [afTranslate]="'move-modal.select-folder'">_Selecciona carpeta de destino</p>
    <div class="common-branch-tree__body-items-container">
      <div class="move-modal__button-new-container">
        @if (moveModal.showNewFolder) {
          <div class="common-dropdown-list__add-items-container">
            <div class="common-dropdown-list__add-items-container-inner">
              <label class="common-text-input__block-field-input"
                [ngClass]="{'common-text-input__block-field-input--with-value': moveModal.nameFolder,
                  'common-text-input__block-field-input--error': moveModal.errorNameFolder }"
                for="create-folder-move-modal">
                <input class="common-text-input__input"
                  type="text"
                  autocomplete="off"
                  id="create-folder-move-modal"
                  name="create-folder-move-modal"
                  [(ngModel)]="moveModal.nameFolder"
                  pAutoFocus
                  [autofocus]="moveModal.showNewFolder"
                  (keydown.enter)="newFolder()"
                  [placeholder]="'common.create-element' | afTranslate"/>
                @if(moveModal.nameFolder){
                  <button class="common-text-input__icon-clean-input"
                    (click)="moveModal.nameFolder = ''">
                    <i class="lf-icon-close-thick common-icon__sm"></i>
                  </button>
                }
              </label>
              <div class="common-button__body-icon-set-sm">
                <button class="common-button__icon-md-noborder"
                  (click)="newFolder()">
                  <i class="lf-icon-check common-icon__md"></i>
                </button>
                <button class="common-button__icon-md-noborder"
                  (click)="closeCreateFolder()">
                  <i class="lf-icon-close common-icon__md"></i>
                </button>
              </div>
            </div>
            @if (moveModal.errorNameFolder) {
              <div class="common-text-input__mandatory-tag">
                <span [afTranslate]="'rename-modal.error-title-folder'">_Ya existe una carpeta con el mismo nombre</span>
              </div>
            }
          </div>
        } @else {
          <button class="common-button__text-noborder"
            (click)="moveModal.showNewFolder = !moveModal.showNewFolder">
            <i class="lf-icon-add-round common-icon__md"></i>
            <span class="common-button__text-title"
              [afTranslate]="'expanded-menu.new-folder'">_Nueva carpeta</span>
          </button>
        }
      </div>
        @if (moveModal.treeFolder.length) {
          <div class="common-branch-tree__body-inner-items-container">
            <div class="common-branch-tree__col-header-item-container">
              <div class="common-branch-tree__space-button-sm"></div>
              <div class="common-button__block-button-md-checkbox">
                <button class="common-button__icon-md-checkbox"
                  [ngClass]="{'common-button__icon-md-checkbox--selected': moveModal.headerTree.documentationCheked}"
                  [disabled]="moveModal.headerTree.disabled"
                  (click)="documentationSelected()">
                  <i class="common-icon__md"
                    [ngClass]="moveModal.headerTree.documentationCheked?'lf-icon-radio-button-active':'lf-icon-step-first'"></i>
                </button>
              </div>
              <div class="common-branch-tree__item-container"
                [ngClass]="{'common-branch-tree__item-container--disabled': moveModal.headerTree.disabled}">
                <i class="lf-icon-documentation common-icon__md"></i>
                <span>{{moveModal.headerTree.name}}</span>
              </div>
            </div>
            @for (folder of moveModal.treeFolder; track $index) {
              <div class="common-branch-tree__col-item-container">
                @if(folder.subFolders.length && !folder.disabledChildren){
                  <button class="common-button__icon-sm-noborder"
                    (click)="folder.show = !folder.show">
                    <i class="common-icon__md"
                      [ngClass]="folder.show?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
                  </button>
                }@else {
                  <div class="common-branch-tree__space-button-sm"></div>
                }
                <div class="common-button__block-button-md-checkbox">
                  <button class="common-button__icon-md-checkbox"
                    [ngClass]="{'common-button__icon-md-checkbox--selected': folder.selected}"
                    [disabled]="folder.disabled"
                    (click)="selectFolder(folder)">
                    <i class="common-icon__md"
                      [ngClass]="folder.selected?'lf-icon-radio-button-active':'lf-icon-step-first'"></i>
                  </button>
                </div>
                <div class="common-branch-tree__item-container"
                  [ngClass]="{'common-branch-tree__item-container--disabled': folder.disabled}">
                  <div class="common-icon__md"
                  [ngClass]="folder.show?'lf-icon-svg-folder-open-md':'lf-icon-svg-folder-md'"></div>
                  <span>{{folder.name}}</span>
                </div>
              </div>
              @if (folder.show) {
                <branch-tree class="common-branch-tree__container-children"
                  [childrenList]="folder.subFolders"
                  [type]="'move'"
                  [level]="1"
                  (selectChildrenEmit)="selectFolder($event.children)">
                </branch-tree>
              }
            }
          </div>
        }@else {
          <div>
            <div class="common-empty-state__message-container"
              [afTranslate]="'move-modal.no-folders-found'">_No se han encontrado carpetas</div>
          </div>
        }
    </div>
    @if (moveModal.showBlockError) {
      <div class="common-status-message__g-container-alert">
        <i class="lf-icon-close-round-full common-status-message__icon-md"></i>
        <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span class="common-status-message__g-subtitle"
                [afTranslate]="'move-modal.error-create'">_No se ha podido crear la carpeta. Por favor intentalo de nuevo</span>
            </div>
            <button class="common-button__icon-xs-noborder"
              (click)="moveModal.showBlockError = !moveModal.showBlockError">
              <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      [disabled]="!moveModal.selectedFolder"
      (click)="moveItem()">
      <span class="common-button__text-title"
        [afTranslate]="'common.move'">_Mover</span>
    </button>
  </div>
</div>
